<template>
  <div class="table screen_table--3">
    <ScrollTable
        :swipe-icon="true"
        class=""
        :delay-before-init="100"
        :fixed-side-class="'table__td--fixed'"
        :resolution="resolution"
        :table-min-width="tableMinWidth"
    >
      <table class="table__wrapper" ref="table">
      <thead class="table__thead">
        <th class="table__th table__th--first table__td--fixed">
          <div class="table__colon_bg" :style="{'height': height + 'px'}"></div>
          <span class="table__th_content">
            Adverse reactions in patients with RMS with an incidence of at least 5% with KESIMPTA and a greater incidence than teriflunomide*
          </span>
        </th>
        <th class="table__th table__th--third">
          <div class="table__colon_bg" :style="{'height': height + 'px'}"></div>
          <div class="table__th_content">
              <b>KESIMPTA</b>
              <br>
              20 mg
              <br>
              n=946
              <br>
              %
          </div>
        </th>
        <th class="table__th table__th--second">
          <div class="table__colon_bg" :style="{'height': height + 'px'}"></div>
          <div class="table__th_content">
            <b>Teriflunomide</b>
            <br>
            14 mg
            <br>
            n=936
            <br>
            %
          </div>
        </th>
      </thead>
      <tbody class="table__tbody">
      <tr>
        <td></td>
        <td style="position:relative;">
          <div class="table__th_decor table__th_decor-white"></div>
        </td>
        <td style="position:relative;">
          <div class="table__th_decor"></div>
        </td>
      </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Upper respiratory tract infections<sup>†</sup>
          </td>
          <td class="table__td table__td--third">
            39
          </td>
          <td class="table__td table__td--second">
            38
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Injection-related reactions (systemic)
          </td>
          <td class="table__td table__td--third">
            21
          </td>
          <td class="table__td table__td--second">
            15
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Headache
          </td>
          <td class="table__td table__td--third">
            13
          </td>
          <td class="table__td table__td--second">
            12
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Injection-site reactions (local)
          </td>
          <td class="table__td table__td--third">
            11
          </td>
          <td class="table__td table__td--second">
            6
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Urinary tract infection
          </td>
          <td class="table__td table__td--third">
            10
          </td>
          <td class="table__td table__td--second">
            8
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Back pain
          </td>
          <td class="table__td table__td--third">
            8
          </td>
          <td class="table__td table__td--second">
            6
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Blood immunoglobulin
            M decreased
          </td>
          <td class="table__td table__td--third">
            6
          </td>
          <td class="table__td table__td--second">
            2
          </td>
        </tr>
      </tbody>
    </table>
    </ScrollTable>
  </div>
</template>

<script>
// components
import ScrollTable from '../ScrollTable/ScrollTable';

// vuex
import { mapState } from 'vuex';

export default {
  name: "Table3",
  data() {
    return {
      height: 0,
    }
  },
  components: {
    ScrollTable,
  },
  computed: {
    ...mapState(['UserAgent']),
    resolution: function () {
      return (
          this.$route.query.screentest_graphs ? Infinity :
          this.UserAgent.window.width >= 1024 ? 1250 : 600
      )
    },
    tableMinWidth: function () {
      return this.UserAgent.window.width >= 1024 ? '500px' : '450px'
    }
  },
  methods: {
    resizeBg() {
      setTimeout(() => {
        if(this.$refs.table) {
          const borderSpace = 8;
          this.height = this.$refs.table.offsetHeight - borderSpace;
        }
      }, 150);
    },
  },
  watch: {
    'UserAgent.window.width'() {
      this.resizeBg();
    }
  },
  mounted() {
    this.resizeBg();
  }
}
</script>

<style scoped lang="scss">
$border-space: 8px;

.table {
  line-height: normal;
  position: relative;
  &__wrapper {
    border-collapse: separate;
    border-spacing: $border-space;
    margin: -$border-space;
    padding-bottom: $border-space;
  }
  &__th {
    font-size: 18px;
    color: $table-color-1;
    position: relative;
    font-weight: 400;
    margin-bottom: 25px;
    @media (max-width: $mobile) {
      font-size: 16px;
    }
    &--first {
      color: $table-bg-3;
      text-align: left;
      font-weight: 700;
    }
    &--second,
    &--third {
      text-align: center;
      min-width: 136px;
    }
    &--third {
      color: white;
    }
  }
  &__th_content {
    position: relative;
  }
  &__th_decor {
    position: absolute;
    top: auto;
    bottom: $border-space/2;
    background-color: $table-color-1;
    height: 1px;
    width: calc(100% - #{$border-space * 2});
    left: $border-space;
    .table__th--third & {
      background-color: white;
    }
    &-white {
      background-color: white;
    }
  }
  &__colon_bg {
    position: absolute;
    width: 100%;
    background-color: $table-bg-1;
    border-radius: 8px;
    top: -$border-space;
    .table__th--first & {
      background-color: white;
      border-radius: 0;
      .scroll_table--cloned & {
        min-height: 1000vh;
      }
    }
    .table__th--third & {
      background-image: linear-gradient(148deg, $table-bg-2 10%, $table-bg-3 89%);
    }
  }
  &__td {
    color: $table-color-1;
    font-size: 18px;
    position: relative;
    @media (max-width: $mobile) {
      font-size: 16px;
    }
    &--subtitle {
      font-size: 12px;
      font-weight: 700;
    }
    &--first {
      overflow: hidden;
      &:after {
        content: "........................................................................................................................................................................................................................................................................................................................................";
        width: 1px;
        display: inline-block;
        font-size: 50%;
      }
    }
    &--second,
    &--third {
      text-align: center;
    }
    &--third {
      color: white;
    }
  }
}
</style>
